/*
------------------------------------------------
Delishop Framework
CTA Delishop
Version: 1.0
Compatible: Shrine Pro 1.5.4
------------------------------------------------
*/

(function () {

    function initCTA(section) {

        if (!section) return;

        // Reservado para futuras mejoras.
        // Esta versión mantiene la sección completamente estática.

    }

    document.addEventListener("DOMContentLoaded", function () {

        document
            .querySelectorAll(".dh-cta")
            .forEach(initCTA);

    });

    document.addEventListener("shopify:section:load", function (event) {

        const section = event.target.querySelector(".dh-cta");

        if (section) {

            initCTA(section);

        }

    });

})();